var YOUTUBE_MESSAGE_ORIGINS = {
    'https://www.youtube.com': true,
    'https://www.youtube-nocookie.com': true
};

function safeJsonParse(value) {
    if (!value || typeof value !== 'string') return null;
    try {
        return JSON.parse(value);
    } catch (e) {
        return null;
    }
}

function addOrUpdateQueryParam(url, key, value) {
    if (!url) return url;

    var hashIndex = url.indexOf('#');
    var hash = hashIndex >= 0 ? url.substring(hashIndex) : '';
    var base = hashIndex >= 0 ? url.substring(0, hashIndex) : url;

    var qIndex = base.indexOf('?');
    var path = qIndex >= 0 ? base.substring(0, qIndex) : base;
    var query = qIndex >= 0 ? base.substring(qIndex + 1) : '';

    var parts = query ? query.split('&') : [];
    var found = false;

    for (var i = 0; i < parts.length; i++) {
        if (!parts[i]) continue;
        var kv = parts[i].split('=');
        var k = decodeURIComponent(kv[0] || '');
        if (k === key) {
            parts[i] = encodeURIComponent(key) + '=' + encodeURIComponent(value);
            found = true;
            break;
        }
    }

    if (!found) {
        parts.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
    }

    return path + '?' + parts.join('&') + hash;
}

function ensureYouTubeIframePostMessageEnabled(iframe) {
    if (!iframe) return;

    var src = iframe.getAttribute('src') || '';
    if (!src) return;

    var updatedSrc = src;

    if (src.indexOf('enablejsapi=1') === -1) {
        updatedSrc = addOrUpdateQueryParam(updatedSrc, 'enablejsapi', '1');
    }

    if (typeof window !== 'undefined' && window.location && window.location.origin) {
        if (updatedSrc.indexOf('origin=') === -1) {
            updatedSrc = addOrUpdateQueryParam(updatedSrc, 'origin', window.location.origin);
        }
    }

    if (updatedSrc !== src) {
        iframe.setAttribute('src', updatedSrc);
    }
}

function postToYouTubePlayer(iframe, message) {
    if (!iframe || !iframe.contentWindow) return;
    try {
        iframe.contentWindow.postMessage(JSON.stringify(message), '*');
    } catch (e) {
        // Ignore cross-domain / serialization issues.
    }
}

function ensureGlobalListener() {
    if (window.__pugYouTubeEmbedControllerListenerAdded) return;
    window.__pugYouTubeEmbedControllerListenerAdded = true;

    if (!window.__pugYouTubeEmbedControllerRegistry) {
        window.__pugYouTubeEmbedControllerRegistry = [];
    }

    window.addEventListener('message', function (event) {
        if (!event) return;
        if (!event.origin || !YOUTUBE_MESSAGE_ORIGINS[event.origin]) return;

        var registry = window.__pugYouTubeEmbedControllerRegistry;
        if (!registry || registry.length === 0) return;

        var entry = null;
        for (var i = 0; i < registry.length; i++) {
            if (registry[i] && registry[i].contentWindow === event.source) {
                entry = registry[i];
                break;
            }
        }
        if (!entry) return;

        var data = typeof event.data === 'string' ? safeJsonParse(event.data) : event.data;
        if (!data) return;

        switch (data.event) {
            case 'onReady':
                entry.$container.trigger('youtube:ready', [data]);
                break;
            case 'onError':
                entry.$container.trigger('youtube:error', [data]);
                break;
            case 'onStateChange':
                if (typeof data.info !== 'number') return;

                var state = data.info;

                if (state === entry.lastPlayerState) return;

                entry.lastPlayerState = state;

                entry.$container.trigger('youtube:stateChange', [state, null]);
                if (state === 1) entry.$container.trigger('youtube:play', [null]);
                if (state === 2) entry.$container.trigger('youtube:pause', [null]);
                if (state === 0) entry.$container.trigger('youtube:ended', [null]);
                break;
            case 'infoDelivery':
                if (data.info && typeof data.info.playerState === 'number') {
                    var infoState = data.info.playerState;
                    if (infoState === entry.lastPlayerState) return;
                    entry.lastPlayerState = infoState;

                    entry.$container.trigger('youtube:stateChange', [infoState, data.info]);
                    if (infoState === 1) entry.$container.trigger('youtube:play', [data.info]);
                    if (infoState === 2) entry.$container.trigger('youtube:pause', [data.info]);
                    if (infoState === 0) entry.$container.trigger('youtube:ended', [data.info]);
                }
                break;
        }
    });
}

function findOrCreateRegistryEntry(iframe, $container) {
    if (!window.__pugYouTubeEmbedControllerRegistry) {
        window.__pugYouTubeEmbedControllerRegistry = [];
    }

    var registry = window.__pugYouTubeEmbedControllerRegistry;
    for (var i = 0; i < registry.length; i++) {
        if (registry[i] && registry[i].contentWindow === iframe.contentWindow) {
            registry[i].$container = $container;
            return registry[i];
        }
    }

    var entry = {
        iframe: iframe,
        contentWindow: iframe.contentWindow,
        $container: $container,
        lastPlayerState: null
    };

    registry.push(entry);
    return entry;
}

function startListening(iframe) {
    postToYouTubePlayer(iframe, { event: 'listening' });
    postToYouTubePlayer(iframe, { event: 'command', func: 'addEventListener', args: ['onStateChange'] });
    postToYouTubePlayer(iframe, { event: 'command', func: 'addEventListener', args: ['onReady'] });
    postToYouTubePlayer(iframe, { event: 'command', func: 'addEventListener', args: ['onError'] });
    postToYouTubePlayer(iframe, { event: 'command', func: 'getPlayerState' });
}

function command(iframe, funcName, args) {
    var msg = { event: 'command', func: funcName };
    if (args && args.length) msg.args = args;
    postToYouTubePlayer(iframe, msg);
}

function attach(options) {
    if (!options || !options.iframe) return null;

    var iframe = options.iframe;
    var $container = options.$container || $(iframe).closest('.Lightbox, .youtube-video');

    ensureGlobalListener();
    ensureYouTubeIframePostMessageEnabled(iframe);

    if (options.videoId) {
        $(iframe).attr('data-youtube-id', options.videoId);
    }

    findOrCreateRegistryEntry(iframe, $container);

    if (!iframe.__pugYouTubeEmbedControllerBound) {
        iframe.__pugYouTubeEmbedControllerBound = true;
        iframe.addEventListener('load', function () {
            startListening(iframe);
        });
    }

    if (options.$modalElement && options.$modalElement.on) {
        options.$modalElement.on('shown.bs.modal', function () {
            startListening(iframe);
        });
    }

    setTimeout(function () {
        startListening(iframe);
    }, 0);

    return {
        iframe: iframe,
        startListening: function () { startListening(iframe); },
        stopVideo: function () { command(iframe, 'stopVideo'); },
        playVideo: function () { command(iframe, 'playVideo'); },
        pauseVideo: function () { command(iframe, 'pauseVideo'); },
        cueVideoById: function (videoId) { if (videoId) command(iframe, 'cueVideoById', [videoId]); },
        loadVideoById: function (videoId) { if (videoId) command(iframe, 'loadVideoById', [videoId]); }
    };
}

module.exports = {
    attach: attach
};
